import axios from "axios";
import config from "../config";

const PodsService = {
    getPODsByTraceId: (traceId: string) => {
        // Ensure API_URL ends with / or the path starts with /
        const baseUrl = config.API_URL?.endsWith('/') ? config.API_URL : `${config.API_URL}/`;
        // The endpoint is public and requires no authentication according to requirements
        return axios.get(`${baseUrl}api/v1/address-pods/${traceId}`);
    },
};

export default PodsService;
